// src/layouts/seller/SellerMasterLayout.js
import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTheme } from "../../contexts/ThemeContext";
import '../../assets/css/seller/layouts/SellerMasterLayout.css';
import SellerSidebar from "../../components/seller/sellersidebar/SellerSidebar";
import SellerTopbar from '../../components/seller/sellertopbar/SellerTopbar';
import useScrollToTop from "../../contexts/UseScrolltoTop";
import AppContext from "../../contexts/AppContext";

const SellerMasterLayout = ({ children }) => {
  useScrollToTop();
  const navigate = useNavigate();
  const { isDark } = useTheme();

  const [isMobileSidebarOpen, setIsMobileSidebarOpen] = useState(false);

  const token = localStorage.getItem("sellerAuthToken");

  if (!token) {
    navigate("/seller/signup");
    return null;
  }

  const toggleMobileSidebar = () => setIsMobileSidebarOpen((prev) => !prev);
  const closeMobileSidebar = () => setIsMobileSidebarOpen(false);

  return (
    <div className={`seller-master-layout ${isDark ? 'dark-mode' : ''}`}>
      <div className="sidebar-col">
        <SellerSidebar
          isMobileOpen={isMobileSidebarOpen}
          onCloseMobile={closeMobileSidebar}
        />
      </div>
      <div className="content-col">
        <SellerTopbar onToggleSidebar={toggleMobileSidebar} />
        <div className="seller-content-wrapper">
          {children}
        </div>
      </div>
    </div>
  );
};

export default SellerMasterLayout;